<script>
    import {store} from '../stores.js';
    
    const axis = store('axis', '', false);
    
    export let title = '';
</script>

<!-- App Header -->
<div class="appHeader">
    {#if !$axis}
        <div class="left"><slot name="left"/></div>
    {/if}
    
    <div class="pageTitle">{title}</div>
    
    {#if !$axis}
        <div class="right"><slot name="right"/></div>
    {/if}
</div>
<!-- * App Header -->
